var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "automation-listing" },
    [
      _vm.isLoadingTable && _vm.allAutomations.length === 0
        ? void 0
        : _vm.allAutomations.length === 0 && !_vm.isProviderDown
        ? _c("AutomationLanding")
        : _vm.isProviderDown
        ? _c("AutomationEmptyStateDisconnectedToProvider", {
            staticClass: "automation-listing__empty-state"
          })
        : _c("LayoutHeadingTabs", {
            attrs: { title: _vm.translations.title },
            scopedSlots: _vm._u([
              {
                key: "actions",
                fn: function() {
                  return [_c("AutomationCreateAutomation")]
                },
                proxy: true
              },
              {
                key: "content",
                fn: function() {
                  return [
                    _c(
                      "div",
                      { staticClass: "automation-listing__content" },
                      [
                        _c("ListingSettingsHeader", {
                          attrs: {
                            columns: _vm.columns,
                            enableColumnsSettings: false,
                            searchable: "",
                            searchValue: _vm.searchValue
                          },
                          on: { search: _vm.searchAttributes }
                        }),
                        _vm._v(" "),
                        _vm.isLoadingTable
                          ? _c("TableLoading")
                          : _c(
                              "CompassTable",
                              {
                                staticClass: "automation-listing__table",
                                attrs: {
                                  size: "large",
                                  border: true,
                                  isCheckable: false
                                }
                              },
                              [
                                _c("AutomationListingTableHead", {
                                  attrs: { columns: _vm.columns },
                                  on: { "sort-table-head": _vm.handleSort }
                                }),
                                _vm._v(" "),
                                !_vm.automations.length
                                  ? _c(
                                      "td",
                                      {
                                        staticClass:
                                          "automation-listing__empty-state__no-result",
                                        attrs: { colspan: "100%" }
                                      },
                                      [
                                        _c(
                                          "AutomationListingEmptyStateNoResult",
                                          {
                                            on: {
                                              "reset-filters": _vm.resetFilters
                                            }
                                          }
                                        )
                                      ],
                                      1
                                    )
                                  : _c(
                                      "CompassTableBody",
                                      _vm._l(_vm.automations, function(
                                        automation,
                                        index
                                      ) {
                                        return _c("AutomationListingTableRow", {
                                          key: index,
                                          attrs: {
                                            automation: automation,
                                            columns: _vm.columns
                                          },
                                          on: {
                                            "update-automation":
                                              _vm.updateAutomation,
                                            "automation-duplicated":
                                              _vm.getAutomations,
                                            "edit-wizard-automation":
                                              _vm.handleEditWizardAutomation
                                          }
                                        })
                                      }),
                                      1
                                    )
                              ],
                              1
                            ),
                        _vm._v(" "),
                        _vm.pagination.total > 0
                          ? _c("TablePagination", {
                              attrs: {
                                pagination: _vm.pagination,
                                isLoading: _vm.isLoadingTable
                              },
                              on: { "update-pagination": _vm.updatePagination }
                            })
                          : _vm._e()
                      ],
                      1
                    )
                  ]
                },
                proxy: true
              }
            ])
          })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }